import React from 'react';
import cn from 'classnames';
import { isEmpty } from './format';
import styles from './card.module.css';

/* Поле карточки: мелкая приглушённая подпись сверху, под ней значение в тонкой
   рамке. Значение — текст, а не input: ввод в режиме невозможен по условию. */
export const Field = ({ label, value, wide = false, mono = false }) => {
  const empty = isEmpty(value);
  return (
    <div className={cn(styles.field, { [styles.fieldWide]: wide })}>
      <span className={styles.fieldLabel}>{label}</span>
      <div className={cn(styles.fieldValue, {
        [styles.fieldEmpty]: empty,
        [styles.mono]: mono && !empty,
      })}
      >
        {empty ? 'не заполнено' : value}
      </div>
    </div>
  );
};

export default Field;
